import { render, staticRenderFns } from "./BreakAfter.vue?vue&type=template&id=c51d9bb8&"
import script from "./BreakAfter.vue?vue&type=script&lang=js&"
export * from "./BreakAfter.vue?vue&type=script&lang=js&"
import style0 from "./BreakAfter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports